import { lazy } from 'react'
import { Navigate } from 'react-router-dom'
import UnAuthGuard from "../guards/UnAuthGuard"

// project import
import Loadable from '../components/Loadable'
import MinimalLayout from '../layout/MinimalLayout'

// render - login
const AuthLogin = Loadable(lazy(() => import('pages/auth/Login')))
const ClientLoginLinkPage = Loadable(lazy(() => import('pages/auth/ClientLoginLinkPage')))
const ForgotPassword = Loadable(lazy(() => import('pages/auth/ForgotPassword')))
const CheckCode = Loadable(lazy(() => import('pages/auth/CheckCode')))
const ResetPassword = Loadable(lazy(() => import('pages/auth/ResetPassword')))

const SignupVerifyPage = Loadable(lazy(() => import('pages/auth/SignupVerifyPage')))
const SignupSuccessPage = Loadable(lazy(() => import('pages/auth/SignupSuccessPage')))
const Signup = Loadable(lazy(() => import('pages/auth/Signup')))


const BookingForm = Loadable(lazy(() => import('pages/booking/BookingForm')))

// ==============================|| AUTH ROUTING ||============================== //

const AnonymousRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      index: true,
      element: <Navigate to="/login" replace />
    },
    {
      path: 'login',
      element: <UnAuthGuard component={<AuthLogin />} />
    },
    {
      path: 'client/login',
      element: <Navigate to="/clientBooking" replace />
    },
    {
      path: 'client/login/link',
      element: <UnAuthGuard component={<ClientLoginLinkPage />} />
    },
    {
      path: 'client/signup',
      element: <UnAuthGuard component={<Signup />} />
    },    
    {
      path: 'client/signup/verify',
      element: <UnAuthGuard component={<SignupVerifyPage />} />
    },
    {
      path: 'client/signup/success',
      element: <UnAuthGuard component={<SignupSuccessPage />} />
    },
    {
      path: 'forgotPassword',
      element: <UnAuthGuard component={<ForgotPassword />} />
    },
    {
      path: 'client/forgotPassword',
      element: <UnAuthGuard component={<ForgotPassword />} />
    },
    {
      path: 'checkCode/:token',
      element: <UnAuthGuard component={<CheckCode />} />
    },
    {
      path: 'resetPassword/:token/:code',
      element: <UnAuthGuard component={<ResetPassword />} />
    },
    {
      path: 'client/resetPassword/:token/:code',
      element: <UnAuthGuard component={<ResetPassword />} />
    },
    {
      path: 'Booking',
      element: <UnAuthGuard component={<BookingForm />} />
    }
  ]
}

export default AnonymousRoutes
